export const SCREEN_NAME_EDIT = 'EditPaymentMethodScreen';
export const SCREEN_NAME_ADD = 'AddPaymentMethodScreen';
